(() => {
  if (document.documentElement.dataset.cbpsScriptLoaded) return;
  document.documentElement.dataset.cbpsScriptLoaded = "true";

  const syncCollectionPanel = (root) => {
    const select = root.querySelector("[data-collection-select]");
    if (!select) return;

    root.querySelectorAll("[data-collection-panel]").forEach((panel) => {
      panel.hidden = panel.id !== select.value;
    });
  };

  const init = (root) => {
    if (root.dataset.cbpsReady) return;
    root.dataset.cbpsReady = "true";
    const select = root.querySelector("[data-collection-select]");
    select?.addEventListener("change", () => syncCollectionPanel(root));
    syncCollectionPanel(root);
    const getQuantity = (card) => {
      const select = card.querySelector("[data-quantity-select]");
      const input = card.querySelector("[data-quantity-input]");
      return select.value === "custom" ? Number(input.value) : Number(select.value);
    };

    const updatePrice = (card) => {
      const quantity = getQuantity(card);
      const priceElement = card.querySelector("[data-product-price]");
      const totalCents = Number(card.dataset.price) * quantity;
      priceElement.dataset.cents = totalCents;

      if (window.CurrencyEngine) {
        window.CurrencyEngine.refresh();
        return;
      }

      const currency =
        window.Shopify && window.Shopify.currency
          ? window.Shopify.currency.active
          : "USD";
      priceElement.textContent = new Intl.NumberFormat(
        document.documentElement.lang || "en-US",
        { style: "currency", currency },
      ).format(totalCents / 100);

      // Update the hidden quantity field in the form
      const formQuantityInput = card.querySelector("[data-form-quantity]");
      if (formQuantityInput) {
        formQuantityInput.value = quantity;
      }
    };

    root.querySelectorAll("[data-quantity-select]").forEach((quantity) => {
      quantity.addEventListener("change", () => {
        const card = quantity.closest("[data-product-card]");
        const input = card.querySelector("[data-quantity-input]");

        if (quantity.value === "custom") {
          const minimum = Number(input.dataset.minThreshold) || 16;
          if (Number(input.value) < minimum) {
            input.value = minimum;
          }
          quantity.hidden = true;
          input.hidden = false;
          input.disabled = false;
          input.focus();
        } else {
          quantity.hidden = false;
          input.hidden = true;
          input.disabled = true;
        }

        updatePrice(card);
      });
    });

    root.querySelectorAll("[data-quantity-input]").forEach((input) => {
      input.addEventListener("input", () => {
        const card = input.closest("[data-product-card]");
        updatePrice(card);
      });

      input.addEventListener("change", () => {
        const card = input.closest("[data-product-card]");
        const minimum = Number(input.dataset.minThreshold) || 16;

        if (Number(input.value) < minimum) {
          const select = card.querySelector("[data-quantity-select]");
          select.value = Math.max(1, Number(input.value) || 1);
          select.hidden = false;
          input.hidden = true;
          input.disabled = true;
        }

        updatePrice(card);
      });
    });

    root.querySelectorAll("product-form").forEach((productForm) => {
      const form = productForm.querySelector("form");
      const animatedButton = productForm.querySelector("button-animated");
      const submitButton = productForm.querySelector("[type='submit']");

      if (!form || !animatedButton || !submitButton) return;

      const setQuantityName = () => {
        document.querySelectorAll("[data-form-quantity]").forEach(el => el.name = "quantity-inactive");
        const quantityInput = form.querySelector("[data-form-quantity]");
        if (quantityInput) {
          quantityInput.name = "quantity";
          quantityInput.value = getQuantity(form.closest("[data-product-card]"));
        }
      };

      submitButton.addEventListener("mousedown", setQuantityName);
      submitButton.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") setQuantityName();
      });

      form.addEventListener("submit", () => {
        animatedButton.dataset.cbpsSubmitting = "true";
      });

      new MutationObserver(() => {
        if (
          animatedButton.dataset.cbpsSubmitting === "true" &&
          !submitButton.classList.contains("loading-process")
        ) {
          delete animatedButton.dataset.cbpsSubmitting;
          animatedButton.onesAnimate?.();
        }
      }).observe(submitButton, { attributes: true, attributeFilter: ["class"] });
    });

    document.addEventListener("currency:changed", () => {
      root.querySelectorAll("[data-product-card]").forEach(updatePrice);
    });
    root.querySelectorAll("[data-popup-open]").forEach((link) =>
      link.addEventListener("click", (e) => {
        e.preventDefault();
        document.querySelector(link.getAttribute("href"))?.showModal();
      }),
    );
    root
      .querySelectorAll("[data-popup-close]")
      .forEach((button) =>
        button.addEventListener("click", () =>
          button.closest("dialog").close(),
        ),
      );
    root.querySelectorAll("[data-popup]").forEach((popup) =>
      popup.addEventListener("click", (event) => {
        if (event.target === popup) popup.close();
      }),
    );
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll("[data-cbps]").forEach(init);
    }, { once: true });
  } else {
    document.querySelectorAll("[data-cbps]").forEach(init);
  }

  window.addEventListener("pageshow", () => {
    document.querySelectorAll("[data-cbps]").forEach(syncCollectionPanel);
  });

  document.addEventListener("shopify:section:load", (e) => {
    const targets = e.target.matches?.("[data-cbps]")
      ? [e.target]
      : (e.target.querySelectorAll?.("[data-cbps]") || []);
    targets.forEach(init);
  });
})();
